exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._130bTpiVu1tLQuUMlyzjBF{display:inline-block}html[dir=ltr] ._130bTpiVu1tLQuUMlyzjBF{padding-right:10px}html[dir=rtl] ._130bTpiVu1tLQuUMlyzjBF{padding-left:10px}", ""]);

// exports
exports.locals = {
	"spinner": "_130bTpiVu1tLQuUMlyzjBF"
};